import { checkApiResponse } from 'Utils'
import accountActions from 'ServicesActions/account'

export const namespaced = true

export const state = {
  catalogue: null,
}

export const mutations = {
  SET_STATUS(state) {
    state.addingCard = !state.addingCard
  },

  SET_CARD_CATALOGUE(state, catalogue) {
    state.catalogue = catalogue
  },
}

export const actions = {
  async loadCatalogue({ commit }, id) {
    const cardCatalogue = await accountActions.get.account(id).cardTemplates()

    if (!checkApiResponse(cardCatalogue)) return cardCatalogue
    commit('SET_CARD_CATALOGUE', cardCatalogue.data)
  },

  change_status({ commit }) {
    commit('SET_STATUS')
  },
}
